/* Step validation notification item to render each step */
const StepsValidationsNotificationsItem = ({ stepName }) => (
  <em className="font-medium !text-black cursor-auto not-italic">{stepName}</em>
);

export default StepsValidationsNotificationsItem;
